import { render, staticRenderFns } from "./AdminAlerts.vue?vue&type=template&id=6902cc4c&"
import script from "./AdminAlerts.vue?vue&type=script&lang=js&"
export * from "./AdminAlerts.vue?vue&type=script&lang=js&"
import style0 from "./AdminAlerts.vue?vue&type=style&index=0&id=6902cc4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports